export default {
  applications: {}, // TODO INSERIR TODA A LEGENDA AQUI
}
